export default "__VITE_ASSET__Bdxk$2ez__"